import advertisersActionTypes from './action-types';

export const fetchAdvertisersList = payload => ({
  type: advertisersActionTypes.FETCH_ADVERTISERS_LIST,
  payload,
});

export const fetchAdvertisersListSuccess = payload => ({
  type: advertisersActionTypes.FETCH_ADVERTISERS_LIST_SUCCESS,
  payload,
});

export const fetchAdvertisersListFail = payload => ({
  type: advertisersActionTypes.FETCH_ADVERTISERS_LIST_FAIL,
  payload,
});

export const fetchAddOrEditAdvertiserSubmission = payload => ({
  type: advertisersActionTypes.FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION,
  payload,
});

export const fetchAddOrEditAdvertiserSubmissionSuccess = payload => ({
  type: advertisersActionTypes.FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION_SUCCESS,
  payload,
});

export const fetchAddOrEditAdvertiserSubmissionFail = payload => ({
  type: advertisersActionTypes.FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION_FAIL,
  payload,
});

export const setAdvertiserDetails = payload => ({
  type: advertisersActionTypes.SET_ADVERTISER_DETAILS,
  payload,
});
